import { render, staticRenderFns } from "./CalendarSync.vue?vue&type=template&id=059f0888&scoped=true"
import script from "./CalendarSync.vue?vue&type=script&lang=js"
export * from "./CalendarSync.vue?vue&type=script&lang=js"
import style0 from "./CalendarSync.vue?vue&type=style&index=0&id=059f0888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f0888",
  null
  
)

export default component.exports